import { render, staticRenderFns } from "./AccountModifyPhone.vue?vue&type=template&id=3cdcb2c7&scoped=true&"
import script from "./AccountModifyPhone.vue?vue&type=script&lang=js&"
export * from "./AccountModifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./AccountModifyPhone.vue?vue&type=style&index=0&id=3cdcb2c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdcb2c7",
  null
  
)

export default component.exports